import React from 'react';

const ThemePageBanner = props => {

    const {image, heading} = props;


    return (
        <div className="container-fluid theme-page-banner" data-aos>
            <div className="image" style ={ { backgroundImage: `url(${image})` } }></div>
            <div className="container">
                <div className="row">
                    <div className="col-12 inner-content">
                        <h1 className="heading-main">{heading}</h1>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ThemePageBanner;


// WEBPACK FOOTER //
// src/client/components/dashboardNew/components/ThemePageBanner.js